import { ChangeDetectionStrategy, Component, computed, ElementRef, input, model, viewChildren } from '@angular/core';
import { NgClass } from '@angular/common';
import { MatButton, MatIconButton } from '@angular/material/button';

@Component({
	selector: 'app-stars',
	standalone: true,
	imports: [NgClass, MatIconButton, MatButton],
	templateUrl: './stars.component.html',
	styleUrl: './stars.component.scss',
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class StarsComponent {
	selectedStarsNumber = model<number>();
	numberOfStars = input<number>(5);
	disabled = input<boolean>(false);
	numOfStarsArray = computed(() => {
		return Array.from({ length: this.numberOfStars() }, (_, i) => i);
	});

	private readonly starElementsRef = viewChildren('starEl', { read: ElementRef });

	setStarsColorOnHover(i: number): void {
		if (this.disabled()) {
			return;
		}
		this.updateStarsColor(i);
	}

	setDefaultColorBaseOnStars(): void {
		if (this.disabled()) {
			return;
		}
		this.updateStarsColor(this.selectedStarsNumber() - 1);
	}

	submitStars(i: number): void {
		if (this.disabled()) {
			return;
		}
		this.selectedStarsNumber.set(i + 1);
	}

	private toggleStarClass(el: HTMLElement, isActive: boolean): void {
		const action = isActive ? 'add' : 'remove';
		el.classList[action]('fas');
		el.classList[action === 'add' ? 'remove' : 'add']('far');
	}

	private updateStarsColor(maxIndex: number): void {
		this.starElementsRef().forEach((el, index) => {
			this.toggleStarClass(el.nativeElement, index <= maxIndex);
		});
	}
}
